























import { Component, Vue, Watch, Prop } from 'vue-property-decorator';
import { namespace } from 'vuex-class';
import {
  AcgnTaskDetail,
  AcgnAuditDetail,
  AcgnOverdueDetail,
  AcgnTargetDetail,
  AcgnLinkDetail
} from './components';
import { Tabs, TabPane } from 'element-ui';

@Component({
  components: {
    [Tabs.name]: Tabs,
    [TabPane.name]: TabPane,
    AcgnTaskDetail,
    AcgnAuditDetail,
    AcgnOverdueDetail,
    AcgnTargetDetail,
    AcgnLinkDetail
  }
})

/**
 * 项目明细-管理方
 */
export default class AcgnStatisticDetail extends Vue {

  @Prop({ default: true }) public isShowTarget: string; // 是否显示目标情况（项目才显示）
  @Prop({ default: null }) public comicId: number | null; // 项目id
  @Prop({ default: null }) public userId: number | null; // 员工id
  @Prop({ default: null }) public onlyOverdue: number | null; // 只显示逾期
  @Prop({ default: '' }) public exportCode: string; // 导出权限码
  @Prop({ default: false }) public isShowModify: boolean; // 显示修改按钮

  private activeName: string = 'one';

  // 1：任务、2：过审、3：逾期、4：目标
  private tabs: any = {
    1: 'one',
    2: 'two',
    3: 'three',
    4: 'four',
    5: 'five'
  };


  private created() {
    const { type } = this.$route.params;
    if (type) {
      this.activeName = this.tabs[type];
    }
  }
}
